// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './select.scss';

function Select({ children, disabled, id, onBlur, onChange, onClick, short, value }) {
    return (
        <select
            {...{
                className: classnames({
            select: true,
                    select_empty: value === '',
                    select_short: short,
          }),
                disabled,
          id,
                onBlur,
                onChange,
          onClick,
                value,
            }}
        >
            {children}
        </select>
    );
}

Select.propTypes = {
    children: PropTypes.node.isRequired,
    // className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    // name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    short: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
};

export default withFormField(Select);
